// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SUBCATEGORY_HMC_KEY {
  'subcategory' = '',
  'subcategoryListingRanges' = 'subcategoryListingRanges',
}
